import type { IconData } from '@stacksjs/iconify-core'

export const entertainmentBooks: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4.08.65H.16v12.74h5.88L8 15.35l1.96-1.96h5.88V.65h-3.92A3.92 3.92 0 0 0 8 4.57A3.92 3.92 0 0 0 4.08.65\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default entertainmentBooks
